import { Component, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'
import { IFlowOrAmendment, FlowOrAmendment, ensureFlowOrAmendment, setControlState } from 'app/shared/utils';
import { FormBuilderTyped } from 'app/shared/form-builder-typed';
import { Validators } from '@angular/forms';
import { OnDestroy, EventEmitter } from '@angular/core';

@Component({
    selector: 'sbw-vehicles-details-row',
    templateUrl: './vehicles-details-row.component.html',
    styleUrls: ['./vehicles-details-row.component.css']
})
export class VehiclesDetailsRowComponent implements OnInit, IFlowOrAmendment, OnDestroy {
    @Input() model: IInputVehicleDetailsRow
    @Input() mode: FlowOrAmendment
    @Input() index: number

    @Input() selectedVehicleControl: FormControl
    @Input() selectedTrailerControl: FormControl

    @Output() created: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()
    @Output() destroyed: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

    form: FormGroup
    get selectedVehicle() {
        return this.selectedVehicleControl.value
    }
    get selectedTrailer() {
        return this.selectedTrailerControl.value
    }

    get selectedVehicleText(): string {
        return this.selectedVehicle && this.selectedVehicle.name
    }
    get selectedTrailerText(): string {
        return this.selectedTrailer && this.selectedTrailer.name
    }
    get isSelectedVehicleEnabled(): boolean {
        return this.selectedVehicle && this.selectedVehicle.registrationNumberIsMandatory
    }
    get isSelectedTrailerEnabled(): boolean {
        return this.selectedTrailer &&
            this.isSelectedVehicleEnabled &&
            this.selectedTrailer.id !== '00000000-0000-0000-0000-000000000000' &&
            this.selectedTrailer.registrationNumberIsMandatory
    }

    get vehicleControl() {
        return this.form.get('vehicleRegistrationNumber')
    }

    get trailerControl() {
        return this.form.get('trailerRegistrationNumber')
    }
    constructor(private fb: FormBuilderTyped) { }

    ngOnInit() {
        ensureFlowOrAmendment(this.mode)
        if (this.mode === 'Flow') {
            this.useFlow()
        } else if (this.mode === 'Amendment') {
            this.useAmendment()
        }
    }
    ngOnDestroy(): void {
        this.destroyed.emit(this.form)
    }
    useFlow() {
        const { vehicleId, vehicleRegistrationNumber, trailerId, trailerRegistrationNumber } = this.model
        this.form = this.fb.group<IInputVehicleDetailsRow>({
            vehicleId: this.fb.control(vehicleId),
            vehicleRegistrationNumber: this.fb.control({ value: vehicleRegistrationNumber, disabled: !this.isSelectedVehicleEnabled }, [Validators.required]),
            trailerId: this.fb.control(trailerId),
            trailerRegistrationNumber: this.fb.control({ value: trailerRegistrationNumber, disabled: !this.isSelectedTrailerEnabled }, [Validators.required])
        })
        this.created.emit(this.form)
    }
    useAmendment() {
        this.selectedVehicleControl.valueChanges.subscribe(vehicle => {
            setControlState(this.vehicleControl, this.isSelectedVehicleEnabled)
            this.form.get('vehicleId').setValue(vehicle.id)
        })

        this.selectedTrailerControl.valueChanges.subscribe(trailer => {
            if (!trailer)
                return

            setControlState(this.trailerControl, this.isSelectedTrailerEnabled)
            this.form.get('trailerId').setValue(trailer.id)
        })
        this.useFlow()
    }
}

export interface IInputVehicleDetailsRow {
    vehicleId: string
    vehicleRegistrationNumber: string
    trailerId?: string
    trailerRegistrationNumber?: string
}
